import type { Paywall } from "@/react/types";

export const getPaywallTitle = (paywall: Paywall) => {
  let title: string;

  if (paywall?.event?.name) {
    title = paywall.event.name;
  } else {
    title = paywall.display_name;
  }

  return title;
};

export const getPaywallDescription = (paywall: Paywall) => {
  let description: string | undefined;

  if (paywall.description) {
    description = paywall.description;
  } else if (paywall.event?.body) {
    description = paywall.event?.body;
  }

  return description;
};
